import type {AssigneePickerAssignee} from '../AssigneePicker'

type GetActorCapabilitiesParams = {
  includeAssignableBots?: boolean
  includeAuthorableBots?: boolean
}

type RepositorySuggestedActorFilter = 'CAN_BE_ASSIGNED' | 'CAN_BE_AUTHOR'

export const getActorCapabilities = ({
  includeAssignableBots,
  includeAuthorableBots,
}: GetActorCapabilitiesParams): RepositorySuggestedActorFilter[] => {
  const capabilities: RepositorySuggestedActorFilter[] = []

  if (includeAssignableBots) {
    capabilities.push('CAN_BE_ASSIGNED')
  }
  if (includeAuthorableBots) {
    capabilities.push('CAN_BE_AUTHOR')
  }

  return capabilities
}

export const formatActorLogin = (actor: AssigneePickerAssignee) => {
  if (actor.isCopilot) return '@copilot'

  if (actor.__typename === 'Bot') {
    return `app/${actor.login}`
  }

  return actor.login
}
